/* 登录状态 */
export default {

    /*验证是否登录*/
    /**
     * 在main.js中使用
     *
     router.beforeEach((to, from, next) = > {
            LoginStatus.check({
                type: 'wechatOauth',
                redirectUrl: '/api/wechat/auth'
            }, next);
        })
     * */
    check: function(option, next) {
        var that = this;
        var option = option || {};
        var data = {
            type: option.type || 'wechatOauth', // wechatOauth:微信授权; login:普通登录
            isRedirect: option.isRedirect || 1, //1 or 0
            redirectUrl: option.redirectUrl || '/login',
            is_pay: option.is_pay || false,   //静默授权   默认false非静默授权
            url: option.url || location.pathname, //需要验证的地址
            callbackUrl: option.callbackUrl || location.pathname + location.search //返回的地址
        };
        // next();
        // debugger
        // localStorage.Authorization = '';
        // localStorage.isLogin = '';
        // localStorage.isDealer = '';
        if(decodeURIComponent(decodeURIComponent(option.callbackUrl))  == data.url && data.url == '/login'){
            data.callbackUrl = '/distribution/personal/index';
        }

        var _callbackUrl = decodeURIComponent(decodeURIComponent(option.callbackUrl));
        
        // if(/^\/(register|login)/i.test(_callbackUrl) && localStorage.Authorization && localStorage.isLogin == 1){
        //     localStorage.Authorization = '';
        //     localStorage.isLogin = '';
        //     localStorage.isDealer = '';
        // }

        // var Authorization = localStorage.Authorization;
        // if(localStorage.Authorization){
        //     tools.cache.set('Authorization', localStorage.Authorization);
        // }
        // if(localStorage.isLogin){
        //     tools.cache.set('isLogin', localStorage.isLogin);
        // }
        //没有签名        
        if (tools.isEmpty(tools.cache.get('Authorization')) && window.canauthinit == 1) {
            that.getSign(option, next);
        } else if (!tools.isEmpty(tools.cache.get('Authorization'))) {
            if (tools.url.params('usertest') && config.environment === 'debug') {
                next();
                return;
            }
            // 微信登录
            if(tools.cache.get('is_wechat_login') == 1){
                //is_wechat_login  1用微信登录，2微信正在登录中
                tools.cache.set('is_wechat_login', 2);
                console.log('is_wechat_login')
                var callback = location.origin + data.callbackUrl;
                // if (tools.cache.get('isAuth') == 1) {
                //     // tools.router.push({path: '/login', query: {callback: callback}});
                //     if (next != undefined) {
                //         next();
                //     } else {
                //         tools.router.push({ path: option.callbackUrl });
                //     }
                //     return;
                // }

                var share_from = '';
                if (tools.url.params('share_from') !== undefined && !isNaN(tools.url.params('share_from'))) {
                    share_from = '&share_from=' + tools.url.params('share_from');
                }
                var url = window.config.api.url + data.redirectUrl +
                    '?callback=' + (encodeURIComponent(callback)) +
                    '&token=' + (tools.cache.get('Authorization')) +
                    '&type=' + 'mp' + share_from;
                if (data.is_pay) {
                    url = url + '&is_pay=1';
                }
                if (!tools.isEmpty(tools.url.params('testuser'))) {
                    url += '&testuser=' + tools.url.params('testuser');
                }

                tools.cache.set('isLogin', 2);

                //that.isLogin('/api/islogins',option,next);
                window.location.href = url;
            }
            else if(tools.cache.get('is_wechat_login') == 2 && tools.cache.get('isLogin') == 2){
                //请求是否登录
                that.isLogin('/api/islogins', option, next);
            }
            //判断是否已登录(没登录或初次)
            else if (tools.cache.get('isLogin') == 0 || tools.cache.get('isLogin') == undefined) {
                if (data.isRedirect === 1 && data.type == 'login' && !tools.noLoginUrl.isUrl(data.url)) {
                    var url = data.callbackUrl;
                    tools.router.push({path: data.redirectUrl, query: {callback: url}});
                }else
                if (tools.noLoginUrl.isUrl(data.url)) {
                    //debugger
                    if (typeof next == 'function') {
                        next();
                        return;
                    }
                    // if (tools.cache.get('noFirst')) {
                    //     if (typeof next == 'function') {
                    //         next();
                    //     }
                    // }else{
                    //     tools.router.push({path: '/bind_wechat', query: {callback: url}});
                    //     return;
                    // }
                    
                }else if(data.url.toLowerCase() == '/distribution/chat' && !!tools.url.params('token')){
                    if (typeof next == 'function') {
                        next();
                    }
                }else if (data.type == 'wechatOauth') {
                    console.log('wechatOauth123456')
                        //debugger
                    var callback = location.origin + data.callbackUrl;

                    if(option.callbackUrl.toLowerCase().indexOf('/register') == 0){

                    }
                    else if (tools.cache.get('isAuth') == 1) {
                        // tools.router.push({path: '/login', query: {callback: callback}});
                        if(tools.cache.get('isUser') == 0 && option.callbackUrl.toLowerCase().indexOf('/register') != 0){
                            tools.router.push({ path: '/bind_wechat',query: {callback: option.callbackUrl}});
                        }
                        else if (next != undefined) {
                            next();
                        } else {
                            tools.router.push({ path: option.callbackUrl });
                        }
                        return;
                    }
                    

                    var share_from = '';
                    if (tools.url.params('share_from') !== undefined && !isNaN(tools.url.params('share_from'))) {
                        share_from = '&share_from=' + tools.url.params('share_from');
                    }
                    var url = window.config.api.url + data.redirectUrl +
                        '?callback=' + (encodeURIComponent(callback)) +
                        '&token=' + (tools.cache.get('Authorization')) +
                        '&type=' + 'mp' + share_from;
                    if (!tools.isEmpty(tools.url.params('testuser'))) {
                        url += '&testuser=' + tools.url.params('testuser');
                    }

                    tools.cache.set('isLogin', 2);

                    //that.isLogin('/api/islogins',option,next);
                    window.location.href = url;
                }else if(data.type == 'login'){
                    // next();
                    //请求是否登录
                    that.isLogin('/api/islogins', option, next);
                }
                return false
            }
            //授权中
            else if (tools.cache.get('isLogin') == 2) {
                //请求是否登录
                that.isLogin('/api/islogins', option, next);
                //that.isLogin('/api/islogins?Authorization=' + tools.cache.get('Authorization'),option,next);
            }
            //通过
            else {
                that.authPath(option, next);
            }
        }
    },
    authPath: function(option, next) {
        // debugger
        let is_dealer = localStorage.isDealer,
            // tools.cache.get('isDealer'),
            is_user = tools.cache.get('isUser'),
            parent = tools.cache.get('parent'),
            is_perfect = tools.cache.get('isPerfect');
        let dealer0_path = /(^\/distribution\/(identityauth|register|chat|goodsdetail))/i, //零售用户能进的
            dealer1_canpath = /(^\/retail\/(cart|info|(order\/activitydetail\/index)|(personal\/(?!.*?index))))/i, //代理商能进的页面
            dealer1_path = /(^((\/index)|(\/$)|($)|(\/(\?))|\/goodsdetail|\/identityauth|(\/distribution\/(register|testgoods))|(\/retail\/)))/i, //代理商不能进的
            dealer2_path = /(^\/distribution\/(index|identityauth|improveidentity|personal|goodsdetail|wallet|stock|goodsorder|question|testgoods|materialorder|chat))/i; //准代理能进的
            option.callbackUrl = decodeURIComponent(decodeURIComponent(option.callbackUrl));
        
        if (/^\/distribution\/chat/i.test(option.callbackUrl)) {
            next();
            return
        }
        if (/^\/goodsdetail_share/i.test(option.callbackUrl)) {
            next();
            return
        }
        if (/^\/bind_wechat/i.test(option.callbackUrl)) {
            if (is_user == 0) {
                next();
                return;
            } 
        }
        if (/^\/register/i.test(option.callbackUrl)) {
            if (typeof next == 'function') {
                next();
                return;
            }
            if (is_user == 0) {
                next();
                return;
            } 
            else if (is_dealer == 0 || is_dealer == 3) { //零售用户或推荐人未审核
                // tools.router.replace({ path: '/retail/personal/index' });
                next();
                return;
            } 
            else if (is_dealer == 1 || is_dealer == 2) { //代理商
                tools.router.replace({ path: '/distribution/personal/index' });
            } 
            // else if (is_dealer == 2) { //准代理
            //     tools.router.replace({ path: '/retail/personal/index' });
            // } 
            else if (typeof next == 'function') {
                next();
            }
        }else if(/^\/login/i.test(option.callbackUrl)){
            next();
            return;
        }else {
            // debugger
            if (is_user == 0 && tools.cache.get('is_wechat_login') != 2) {
                tools.router.replace({ path: '/bind_wechat', query: { callback: option.callbackUrl } });
            } else if (is_dealer == 0 && tools.cache.get('parent') == 1) { //有推荐人的零售用户，进入分销商城页面

                /*if(/^\/distribution\/testgoods\/goodsdetail/i.test(option.callbackUrl)){//由试销商品详情分享的
                    tools.router.replace({path: option.callbackUrl.replace(/\/distribution\/testgoods/g,'/retail')});
                }
                else */
                if (dealer0_path.test(option.callbackUrl)) { //有推荐人的零售用户，进入的分销商城页面
                    next();
                // } else if (/^\/distribution/i.test(option.callbackUrl)) { //其它的分销商城页面不能进入
                //     tools.router.replace({ path: '/retail/personal/index' });
                } else {
                    next();
                }
            // } else if (is_dealer == 0 && /^((\/$)|(\/index$)|(\/(\?)))/i.test(option.callbackUrl)) {
            //     tools.router.replace({ path: '/retail/personal/index' });
            } else if (is_dealer == 0 && /^\/distribution/i.test(option.callbackUrl)&&!/^\/distribution\/goodscomb/i.test(option.callbackUrl)) { //没推荐人的零售用户，不能进入分销商城页面
                // 2021-9月优化 零售用户也可进入分销商城
                // tools.router.replace({ path: '/retail/personal/index' });
                // tools.router.replace({ path: '/distribution/personal/index' });
                if (tools.lv0CantPath.isUrl(option.callbackUrl)) {
                    // 普通用户不能进入的页面都跳转回个人中心页面
                    tools.router.replace({ path: '/distribution/personal/index' });
                } else {
                    next(); 
                }
            }  else if (tools.cache.get('parent') == 0 && /^\/yunindex/i.test(option.callbackUrl)) { //没推荐人的零售用户，不能进入云商城页面
                tools.router.replace({ path: '/index' });
            } else if (is_dealer == 1 && dealer1_canpath.test(option.callbackUrl)){ //代理商能进入的页面
                next();
            } else if (is_dealer == 2 && (dealer1_canpath.test(option.callbackUrl) || dealer1_path.test(option.callbackUrl))) {
                next();
            } else if ((is_dealer == 1 || is_dealer == 2) && dealer1_path.test(option.callbackUrl)) { //代理商，不能进入的页面
                tools.router.replace({ path: '/distribution/personal/index' });
            } else if (is_dealer == 2) {
                next();
            }
            else if (typeof next == 'function') {
                next();
            }
        }
    },
    /* 获取签名 */
    getSign: function(option, next) {
        var that = this;
        log.debug('开始获取签名');
        window.canauthinit = 0;
        var token = tools.url.params('token');
        if(/(^\/distribution\/(chat))/i.test(option.callbackUrl) && token){
            tools.cache.set('Authorization', token);
            // localStorage.Authorization = token;
            that.check(option, next);
            window.canauthinit = 1;
            // $('#weixin').remove();
        }else{
            tools.ajax({
                url: '/api/init',
                ajaxData: {},
                successFun: function(response) {
                    log.debug('获取到签名:', response);
                    tools.cache.set('Authorization', response.token);
                    // localStorage.Authorization = response.token;
                    //重新check
                    that.check(option, next);
    
                    //重新check                        
                    /*tools.loginStatus.check({
                        type: 'wechatOauth',                   // wechatOauth, login
                        redirectUrl: '/api/wechat/auth',       //验证不通过跳转的地址
                        url: tools.router.currentRoute.path,   //需要验证的地址
                        callbackUrl: tools.router.currentRoute.fullPath   //返回的地址
                    });*/
                    window.canauthinit = 1;
                },
                errorFun: function(error) {
                    log.error('获取签名失败');
                    window.canauthinit = 1;
                },
                type: 'GET'
            });
        }
        
    },

    /* 获取是否登录 */
    isLogin: function(url, option, next) {
        var that = this;
        log.debug('loginStatus获取是否登录');
        tools.ajax({
            url: url,
            ajaxData: {},
            successFun: function(res) {
                tools.cache.set('isUser', res.data.is_user);
                tools.cache.set('isDealer', res.data.is_dealer);
                tools.cache.set('level', res.data.level_id);
                localStorage.isDealer = res.data.is_dealer;

                tools.cache.set('isSubscribe', res.data.is_subscribe);
                tools.cache.set('mpQrcode', res.data.mp_qrcode);
                tools.cache.set('parent', res.data.parent);
                tools.cache.set('isPerfect', res.data.is_perfect);
                tools.cache.set('isOpenGroup', res.data.is_open_group);
                tools.cache.set('isAuth', res.data.is_wechat_auth);
                tools.cache.set('isPay', res.data.is_pay);

                /*if(!res.data.is_dealer){                        
                    //重新check
                    that.check(option,next);
                    return;
                }*/

                // debugger

                // option.callbackUrl = decodeURIComponent(decodeURIComponent(option.callbackUrl));

                if (tools.noLoginUrl.isUrl(option.callbackUrl)) {
                    // debugger
                    if (typeof next == 'function') {
                        next();
                    }
                }else if(option.callbackUrl.toLowerCase() == '/distribution/chat' && !!tools.url.params('token')){
                    if (typeof next == 'function') {
                        next();
                    }
                }else if(option.type == 'wechatOauth'){

                    // 可以直接访问的页面
                    var canAccessPath = /(^\/(register))/i;
                    if(canAccessPath.test(option.callbackUrl)){
                        next();
                        return;
                    } else if (res.data.is_wechat_auth == 1 && res.data.is_user == 0) { //授权成功，未登录
                        tools.cache.set('isLogin', 0);
                        tools.cache.set('isAuth', 1);
                        // if(res.data.is_wechat_auth){
                        //     tools.cache.set('isLogin', 1);
                        //     tools.router.replace({ 'path': '/login', query: { type: 2,is_wechat: 1 } });
                        // }else if (tools.noLoginUrl.isUrl(option.url)) {
                        //     next();
                        // } else {
                        //     tools.router.replace({ 'path': '/login', query: { callback: option.callbackUrl } });
                        // }
                        tools.cache.set('isLogin', 1);
                        tools.router.replace({ 'path': '/bind_wechat', query: { type: 2,is_wechat: 1 ,callback:option.callbackUrl } });
    
                    } else if (res.data.is_wechat_auth == 0 && res.data.is_user == 0) { //授权失败
                        tools.cache.set('isAuth', 0);
                        tools.cache.set('isLogin', 0);
    
                        //重新check
                        that.check(option, next);
                        return;
                        // if(canAccessPath.test(tools.router.currentRoute.path)){
                        //     tools.router.push({ 'path': '/login', query: { callback: option.callbackUrl } });
                        // }else{
                        //     tools.router.replace({ 'path': '/login', query: { callback: option.callbackUrl } });
                        // }
    
                    } else if (res.data.is_user == 1) { //已登录
                        tools.cache.set('isAuth', 1);
                        tools.cache.set('isLogin', 1);
                        //console.log(`is_perfect : ${res.data.is_perfect}`);
                        // debugger
                        // if (res.data.is_perfect === 0 && res.data.is_dealer > 0) {
                        //     tools.router.replace({ 'path': '/distribution/improveidentity', query: { callback: option.callbackUrl } });
                        // } else {
                        //     if(option.url == '/login'){
                        //         var cburl = tools.url.params('callback');
                        //         if(res.data.is_dealer == 0){
                        //             tools.router.replace({ 'path': (cburl ? decodeURIComponent(cburl) : '/retail/personal/index') });
                        //         }else{
                        //             tools.router.replace({ 'path': (cburl ? decodeURIComponent(cburl) : '/distribution/personal/index') });
                        //         }
                        //     }else{
                        //         that.authPath(option, next);
                        //     }
                        // }
                        if(option.url == '/login'){
                            var cburl = tools.url.params('callback');
                            // 普通用户也能进入加盟商中心，故注释
                            // if(res.data.is_dealer == 0){
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/retail/personal/index') });
                            // }else{
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                            // }
                            tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                        }else{
                            that.authPath(option, next);
                        }
    
                    }
                }
                else if(option.type == 'login'){
                    // 可以直接访问的页面
                    var canAccessPath = /(^\/(register))/i;
                    if(canAccessPath.test(option.callbackUrl)){
                        next();
                        return;
                    } else if (res.data.is_user == 0) { //未登录
                        tools.cache.set('isLogin', 0);
                        tools.router.replace({ 'path': '/bind_wechat', query: { type: 2,is_wechat: 1 ,callback:option.callbackUrl } });
                    }
                    else if (res.data.is_user == 1) { //已登录
                        tools.cache.set('isLogin', 1);
                        if(option.url == '/login'){
                            var cburl = tools.url.params('callback');
                            // 普通用户也能进入加盟商中心，故注释
                            // if(res.data.is_dealer == 0){
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/retail/personal/index') });
                            // }else{
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                            // }
                            tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                        }else{
                            that.authPath(option, next);
                        }
                    }
                }
            },
            errorFun: function(error) {
                log.error('登录失败!');
                tools.alert.error('登录失败!');
                tools.cache.set('isLogin', 0);
                tools.cache.set('isAuth', 0);

                tools.cache.set('isUser', '');
                tools.cache.set('username', '');
                tools.cache.set('userId', '');
                tools.cache.set('isDealer', '');
                tools.cache.set('isPerfect', '');
                tools.cache.set('parent', '');
                tools.cache.set('loginState', '');
                tools.cache.set('is_wechat_login', '');
                // tools.cache.set('Authorization', '');
                tools.cache.set('level', '');
                localStorage.Authorization = '';
                localStorage.isLogin = '';
                localStorage.isDealer = '';
                //重新check
                that.check(option, next);
            },
            type: 'GET'
        });
    },
    checkLogin: function(option, next) {
        var that = this;
        log.debug('获取是否登录 loginStatus:439');
        // debugger
        tools.ajax({
            url: '/api/islogins',
            ajaxData: {},
            successFun: function(res) {
                tools.cache.set('loginData', JSON.stringify(res.data));
                tools.cache.set('isUser', res.data.is_user);
                tools.cache.set('level', res.data.level_id);
                tools.cache.set('isDealer', res.data.is_dealer);
                localStorage.isDealer = res.data.is_dealer;

                tools.cache.set('isSubscribe', res.data.is_subscribe);
                tools.cache.set('mpQrcode', res.data.mp_qrcode);
                tools.cache.set('parent', res.data.parent);
                tools.cache.set('isPerfect', res.data.is_perfect);
                tools.cache.set('isOpenGroup', res.data.is_open_group);
                tools.cache.set('isAuth', res.data.is_wechat_auth);
                tools.cache.set('isPay', res.data.is_pay);

                // debugger
                if(res.data.typeface == 2){
                    tools.cache.set('is_traditional', 1);
                }
                // debugger
                
                // 可以直接访问的页面
                // var canAccessPath = /(^\/(register))/i;
                // if(canAccessPath.test(option.callbackUrl)){
                //     console.log('重新check');
                //     //重新check
                //     that.check(option, next);
                //     return;
                // }
                // 判断是否停机维护
                if (res.data.is_testing==1) {
                    if (option.url=='/update') {
                        next();
                        return;
                    }
                    tools.router.replace({ 'path': '/update' });
                  
                    // if(res.data.is_testing == 1) {
                    //     tools.router.replace({ 'path': '/update' });
                    //     return;
                    // } else {
                    //     tools.router.replace({ 'path': '/' });
                    //     return;
                    // }
                    tools.router.replace({ 'path': '/update' });
                    return;
                }else if(!res.data.is_testing&&option.url=='/update'){
                    tools.router.replace({ 'path': '/' });
                    return;
                }

                if (tools.noLoginUrl.isUrl(option.url)) {
                    // debugger
                    if (typeof next == 'function') {
                        next();
                    }
                }else if(option.callbackUrl.toLowerCase() == '/distribution/chat' && !!tools.url.params('token')){
                    if (typeof next == 'function') {
                        next();
                    }
                }else if(option.type == 'wechatOauth'){

                    if (res.data.is_wechat_auth == 1 && res.data.is_user == 0) { //授权成功，未登录
                        tools.cache.set('isLogin', 0);
                        tools.cache.set('isAuth', 1);
                        if(decodeURIComponent(decodeURIComponent(option.callbackUrl)) == '/bind_wechat'){
                            next();
                        }else{
                            //重新check
                            that.check(option, next);
                            return
                        }
                        // else{
                        //     tools.router.replace({ 'path': '/bind_wechat', query: { callback: option.callbackUrl }});

                        // }
    
                    } else if (res.data.is_wechat_auth == 0 && res.data.is_user == 0) { //授权失败
                        tools.cache.set('isAuth', 0);
                        tools.cache.set('isLogin', 0);
                        //重新check
                        that.check(option, next);
                        return
                        // if(canAccessPath.test(tools.router.currentRoute.path)){
                        //     tools.router.push({ 'path': '/login', query: { callback: option.callbackUrl } });
                        // }else{
                        //     tools.router.replace({ 'path': '/login', query: { callback: option.callbackUrl } });
                        // }
    
                    } else if (res.data.is_user == 1) { //已登录
                        tools.cache.set('isAuth', 1);
                        tools.cache.set('isLogin', 1);
                        if(option.url == '/login'){
                            var cburl = tools.url.params('callback');
                            // 普通用户也能进入加盟商中心，故注释
                            // if(res.data.is_dealer == 0){
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/retail/personal/index') });
                            // }else{
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                            // }
                            tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                        }else{
                            that.authPath(option, next);
                        }
    
                    }

                }
                else if(option.type == 'login'){
                    // 可以直接访问的页面
                    var canAccessPath = /(^\/(register))/i;
                    if(canAccessPath.test(option.callbackUrl)){
                        next();
                        return;
                    } else if (res.data.is_user == 0) { //未登录
                        tools.cache.set('isLogin', 0);
                        tools.router.replace({ 'path': '/bind_wechat', query: { callback:option.callbackUrl } });
                    }
                    else if (res.data.is_user == 1) { //已登录
                        tools.cache.set('isLogin', 1);
                        if(option.url == '/login'){
                            var cburl = tools.url.params('callback');
                            // 普通用户也能进入加盟商中心，故注释
                            // if(res.data.is_dealer == 0){
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/retail/personal/index') });
                            // }else{
                            //     tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                            // }
                            tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                        }else{
                            that.authPath(option, next);
                        }
                    }
                }
                else{
                    that.check(option, next);
                }
                


            },
            errorFun: function(error) {
                log.error('登录失败!');
                tools.alert.error('登录失败!');
                tools.cache.set('isLogin', 0);
                tools.cache.set('isAuth', 0);

                tools.cache.set('isUser', '');
                tools.cache.set('username', '');
                tools.cache.set('userId', '');
                tools.cache.set('isDealer', '');
                tools.cache.set('isPerfect', '');
                tools.cache.set('parent', '');
                tools.cache.set('loginState', '');
                tools.cache.set('is_wechat_login', '');
                tools.cache.set('level', '');
                localStorage.isLogin = '';
                localStorage.isDealer = '';
                //重新check
                // that.check(option, next);
            },
            type: 'GET'
        });
    },
}


// WEBPACK FOOTER //
// ./src/common/loginStatus.js